import { AxiosError } from 'axios'

export interface ApiFailureBody<TData = Record<string, unknown>> {
  status: 'failure'
  message: string
  data?: TData
}

export function isAxiosError<T = unknown>(error: unknown): error is AxiosError<T> {
  return error instanceof AxiosError
}

export function getErrorStatus(error: unknown): number | undefined {
  return isAxiosError(error) ? error.response?.status : undefined
}

export function getErrorMessage(error: unknown, fallback = 'Something went wrong'): string {
  if (!isAxiosError<ApiFailureBody>(error)) {return fallback}
  return error.response?.data?.message ?? fallback
}

export function isConflictError<TData = Record<string, unknown>>(
  error: unknown,
): error is AxiosError<ApiFailureBody<TData>> {
  return isAxiosError<ApiFailureBody<TData>>(error) && error.response?.status === 409
}

export function getConflictData<TData = Record<string, unknown>>(
  error: unknown,
): TData | undefined {
  return isConflictError<TData>(error) ? error.response?.data?.data : undefined
}
